import React, { useEffect, useState } from 'react'
import Sidebar from '../../layouts/sidebar'
import Header from '../../layouts/header'
import Layout from '../../layouts/layout'
import PageHeading from '../../layouts/pageHeading'
import { Box, FormControl, FormControlLabel, Grid, Link as MuiLink, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { cssProperties } from '../../utils/commonCssProperties'
import { MdKeyboardArrowDown } from 'react-icons/md'
import Cookies from "js-cookie";
import DangerButton from '../../common/button/DangerButton'
import { useDispatch, useSelector } from 'react-redux'
import objectionTrackerActions from '../../redux/objectionTracker/actions'
import PrintDownloadButton from '../../common/button/printDownloadButton'

const ViewObjection = () => {
    const [status, setStatus] = useState("")
    const [error, setError] = useState({ status: false, reason: false });
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams();
    const objid = searchParams.get("objid");
    const courseid = searchParams.get("courseid");
    const data = useLocation().state

    const [reason, setReason] = useState(); // Initial state

    
    const objQuestionDetails = useSelector((state) => state.objectionTrackerReducer?.objQuestionDetails);
    
    // Find the specific question details
    const selectedQuestion = objQuestionDetails?.find(
        (item) => item.objectionquestionid == objid // Ensure types match or use '==' for loose comparison
    );
    
    
    const handleChange = (event) => {
      setReason(event.target.value); // Update state on change
    };

    useEffect(() => {
        
        if (selectedQuestion?.reviewercomment) {
            setReason(selectedQuestion?.reviewercomment);
        }
        if (selectedQuestion?.isreviewerapproved) {
            setStatus(selectedQuestion?.isreviewerapproved == '1' ? 'accepted': selectedQuestion?.isreviewerapproved == '0' ? 'rejected': "");
        }
    }, [selectedQuestion]); // Runs only when `selectedQuestion` changes
    

    const handleSubmit = () => {
        let hasError = false;
        let newError = { status: false, reason: false };
    
        if (!status) {
            newError.status = true;
            hasError = true;
        }
        
        if (!reason?.trim()) {
            newError.reason = true;
            hasError = true;
        }
    
        setError(newError);
    
        if (hasError) return; // Stop submission if errors exist
    
        dispatch({
            type: objectionTrackerActions.UPDATE_OBJECTION_QUESTION_DETAILS,
            payload: {
                objid: objid,
                status: status === 'rejected' ? 0 : status === "accepted" ? 1 : null,
                comment: reason,
                courseid:courseid,
                navigate:navigate
            }
        });
    };
    

    useEffect(() => {
          dispatch({
            type: objectionTrackerActions.GET_OBJECTION_QUESTION_DETAILS,
            payload: { courseid: courseid },
          });
      }, []);

    
    const breadcrumbs = [
        <MuiLink underline="hover" key="1" component={NavLink} to={`/${Cookies.get('mhet_mst_project')}/home`} sx={{
            color: cssProperties?.fontcolor?.primary,
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '0.1px'
        }}>
            Dashboard
        </MuiLink>,
        <Typography key="3" color="text.primary"
            sx={{
                display: 'flex', alignItems: 'center', gap: '12px', color: cssProperties?.fontcolor?.primary,
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px',
                letterSpacing: '0.1px'
            }}
        >
            View Objection <MdKeyboardArrowDown size={16} />
        </Typography>,
    ];
    // const handleSubmit = () => {
      
    //         // navigate(`/${Cookies.get('mhet_mst_project')}/home`);
    //         dispatch({ type: objectionTrackerActions.UPDATE_OBJECTION_QUESTION_DETAILS,payload:{objid:objid,status:status == 'rejected' ? 0 : status == "accepted" ? 1 : null,comment:reason} });



    //     }
    const handleBack = () => {
      
            navigate(`/${Cookies.get('mhet_mst_project')}/view-objections`);
            // dispatch({ type: objectionTrackerActions.UPDATE_OBJECTION_QUESTION_DETAILS,payload:{objid:objid,status:status == 'rejected' ? 0 : status == "accepted" ? 1 : null,comment:reason} });
        }
    return (
        <>
            <Sidebar />
            <Header breadcrumbs={breadcrumbs} />
            <Layout>
                <PageHeading title={'View Objection'} />
                <Grid>
                    <Grid
                        p={2}
                        style={{
                            minHeight: "74vh",
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                        }}
                    >
                        {/* <Typography variant="h4" sx={{ fontSize: "24px" }}>
            Ticket Raiser details
          </Typography> */}
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Question No
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.questionno}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Question Details
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                            <Box sx={{display:"flex",justifyContent:"center",alignItems:"center"}}><Box >
           <img src={selectedQuestion?.questiondetails} height={"200px"} width={"90%"} alt='question' />
          </Box>
          </Box>
                            </Grid>

                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Answer Key
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.answerkey}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Book Title
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.booktitle}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Author name
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.authorname}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Edition
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.edition}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Reference Details
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.reference_text}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Reference Document
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                           <a href={selectedQuestion?.documenturl} target='_blank'>view</a>
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Your Response
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    value={selectedQuestion?.responsekey}
                                    placeholder="Enter the name"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>





                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Objection Details
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <Box

                                    sx={{
                                        width: "100%", padding: 1, borderRadius: '4px', border: `1px solid rgba(118, 118, 118, 0.4)`
                                    }}
                                >

                                    <Typography sx={{ color: 'rgba(0, 0, 0, 0.38)', fontSize: "1rem" }} variant='body2'>{`Selected Option :${selectedQuestion?.responsekey ? selectedQuestion?.responsekey : ""}`}</Typography>
                                    <Typography sx={{ pt: 2, color: 'rgba(0, 0, 0, 0.38)', fontSize: "1rem" }} variant='body2'>{`Reason : ${selectedQuestion?.objectionreason ? selectedQuestion?.objectionreason : ""}`}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                    Action
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <FormControl error={error.status}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                        
                                    >
                                        <FormControlLabel disabled={selectedQuestion?.isreviewerapproved == 1 || selectedQuestion?.isreviewerapproved == 0} value="accepted" control={<Radio />} label="Accept" />
                                        <FormControlLabel disabled={selectedQuestion?.isreviewerapproved == 1 || selectedQuestion?.isreviewerapproved == 0} value="rejected" control={<Radio />} label="Reject" />


                                    </RadioGroup>
                                    {error.status && <Typography color="error">Please select a status</Typography>}

                                </FormControl>
                            </Grid>









                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item md={3} lg={3} xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                   Reason
                                </Typography>
                            </Grid>
                            <Grid item md={9} lg={9} xs={12}>
                                <TextField

                                    disabled={selectedQuestion?.isreviewerapproved == 1 || selectedQuestion?.isreviewerapproved == 0}
                                    helperText={error.reason ? "Please enter a reason" : ""}
                                    error={error.reason}
                                    multiline
                                    minRows={3}
                                    fullWidth
                                    size="small"
                                    placeholder="Enter the reason"
                                    sx={{ width: "100%" }}
                                    value={reason} // Bind state to input value
                                    onChange={handleChange} // Update state on change
                                />
                            </Grid>





                        </Grid>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 ,gap:4}}>
                          
<DangerButton handleSubmit={handleBack} title="Back" />
{(selectedQuestion?.isreviewerapproved != 1 && selectedQuestion?.isreviewerapproved != 0) &&
<PrintDownloadButton handleSubmit={handleSubmit}  name="Submit" />}

                        
                            
                        </Box>
                    </Grid>
                </Grid>

            </Layout>
        </>
    )
}

export default ViewObjection
